import { UserRole } from "../@types/userRole";

export const getUserTypeFromRole = (user: UserRole): number => {
  switch(user){
    case "Administrator": return 1;
    case "Analyst": return 2;
    case "Consumer": return 3;
  }
}